var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import codeMirror from 'codemirror';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
function noop() { }
var RcCodeMirror = /** @class */ (function (_super) {
    __extends(RcCodeMirror, _super);
    function RcCodeMirror(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            $self: _this,
        };
        return _this;
    }
    RcCodeMirror.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps, $self = _a.$self;
        var nextState = {
            prevProps: props,
        };
        if (prevProps && props.value && props.value !== $self.editor.getValue()) {
            $self.updated = true;
            $self.editor.setValue(props.value);
        }
        return nextState;
    };
    RcCodeMirror.prototype.componentDidMount = function () {
        var _this = this;
        this.editor = codeMirror(this.ref);
        this.editor.on('change', function (_, metadata) {
            if (_this.props.onChange && !_this.updated) {
                _this.props.onChange(_this.editor, metadata, _this.editor.getValue());
            }
        });
        this.editor.on('blur', function (_, metadata) {
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.editor, metadata, _this.editor.getValue());
            }
        });
        if (this.props.onKeyUp) {
            this.editor.on('keyup', function (_, event) {
                _this.props.onKeyUp(_this.editor, event);
            });
        }
        this.editor.on('keydown', function (_, event) {
            _this.updated = false;
            _this.props.onKeyDown(_this.editor, event);
        });
        Object.keys(this.props.options).forEach(function (key) {
            _this.editor.setOption(key, _this.props.options[key]);
        });
        this.editor.setValue(this.props.value);
    };
    RcCodeMirror.prototype.render = function () {
        var _a;
        var _this = this;
        var className = classnames((_a = {
                'react-codemirror': true
            },
            _a[this.props.className] = !!this.props.className,
            _a));
        return (React.createElement("div", { className: className, ref: function (self) { _this.ref = self; } }));
    };
    RcCodeMirror.propTypes = {
        className: PropTypes.string,
        options: PropTypes.object,
        value: PropTypes.string,
        onChange: PropTypes.func,
        onKeyDown: PropTypes.func,
        onKeyUp: PropTypes.func,
        onBlur: PropTypes.func,
    };
    RcCodeMirror.defaultProps = {
        options: {},
        value: '',
        onChange: noop,
        onKeyDown: noop,
        onKeyUp: noop,
    };
    return RcCodeMirror;
}(React.Component));
export default polyfill(RcCodeMirror);
